import { render, staticRenderFns } from "./journalRecommend.vue?vue&type=template&id=f3e73f2c&scoped=true"
import script from "./journalRecommend.vue?vue&type=script&lang=js"
export * from "./journalRecommend.vue?vue&type=script&lang=js"
import style0 from "./journalRecommend.vue?vue&type=style&index=0&id=f3e73f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e73f2c",
  null
  
)

export default component.exports